import { isBundleAppAndInstalled, isBundleAppAndNotInstalled, } from '../../common/utils';
import { getReferralInfo, getRouteForBi } from '../../common/bi-events';
export var getWebSolutionsBiData = function (solutions, impressionType, tagName, msid, route, prevRoute, bundleApps, collimp_id, section) {
    if (solutions) {
        var _a = getRouteForBi(route, prevRoute), market_1 = _a.market, subCategory_1 = _a.subCategory;
        return solutions.map(function (solution, index) {
            return {
                msid: msid,
                appId: solution === null || solution === void 0 ? void 0 : solution.id,
                impressionType: impressionType,
                index: index,
                market: market_1,
                tagName: tagName.replace(/-/g, '_'),
                tagType: 'homepage',
                subCategory: subCategory_1,
                section: section || tagName.replace(/-/g, '_'),
                referralInfo: getReferralInfo(route.referral, prevRoute),
                searchTerm: route.query ? route.query : prevRoute && prevRoute.query,
                isBundleAppNotInstalled: isBundleAppAndNotInstalled(solution === null || solution === void 0 ? void 0 : solution.id, bundleApps),
                isBundleAppInstalled: isBundleAppAndInstalled(solution === null || solution === void 0 ? void 0 : solution.id, bundleApps),
                collimp_id: collimp_id,
            };
        });
    }
    return [];
};
export var getTagBiData = function (tags, tagName, tagTypeClicked, widgetType, msid, route, prevRoute) {
    if (tags) {
        var market_2 = getRouteForBi(route, prevRoute).market;
        return tags.map(function (tag, index) {
            return {
                index: index,
                msid: msid,
                market: market_2,
                widgetType: widgetType,
                tagName: tagName.replace(/-/g, '_'),
                tagNameClicked: tag === null || tag === void 0 ? void 0 : tag.slug.replace(/-/g, '_'),
                tagType: 'homepage',
                tagTypeClicked: tagTypeClicked,
            };
        });
    }
};
//# sourceMappingURL=biData.js.map